import _extends from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.find-index.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __rest, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useRef, useEffect, useImperativeHandle } from 'react';
import { Dropdown, SearchBar } from 'antd-mobile';
import { isFunction } from 'lodash';
import '../styles/index.less.js';
import { SearchOutline } from 'antd-mobile-icons';
import classNames from 'classnames';
import useControlledState from '../../hooks/useControlledState/index.js';
import Selector from '../../TiSelector/index.js';

var transConfigToOptions = function transConfigToOptions(configs) {
  if (configs === void 0) {
    configs = [];
  }
  return configs.map(function (x) {
    return {
      value: x.key,
      label: x.label
    };
  });
};
var TiSearchBar = function TiSearchBar(props, ref) {
  var dropRef = useRef(null);
  var className = props.className,
    style = props.style,
    showSearchText = props.showSearchText,
    searchText = props.searchText,
    onSearch = props.onSearch,
    configs = props.configs,
    config = props.config,
    onConfigChange = props.onConfigChange,
    defaultConfig = props.defaultConfig;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props.value;
    var onChange = props.onChange,
    rest = __rest(props, ["className", "style", "showSearchText", "searchText", "onSearch", "configs", "config", "onConfigChange", "defaultConfig", "value", "onChange"]);
  var _default = __assign({
    keyword: ''
  }, defaultConfig || configs[0]);
  var _a = useControlledState(_default, {
      value: config,
      onChange: function onChange(changed) {
        if (isFunction(onConfigChange)) {
          var current = configs.find(function (x) {
            return x.key === changed.key;
          });
          onConfigChange(__assign(__assign({}, current), {
            keyword: changed.keyword
          }));
        }
      }
    }),
    state = _a[0],
    setState = _a[1];
  var isMulti = (configs === null || configs === void 0 ? void 0 : configs.length) > 1;
  useEffect(function () {
    return function () {
      closeDrop();
    };
  }, []);
  var closeDrop = function closeDrop() {
    var _a;
    (_a = dropRef === null || dropRef === void 0 ? void 0 : dropRef.current) === null || _a === void 0 ? void 0 : _a.close();
  };
  useImperativeHandle(ref, function () {
    return {
      onDropClose: closeDrop
    };
  });
  var options = transConfigToOptions(configs);
  var mergeCls = classNames('ti-search-bar-wrap', className);
  var handleSelectorChange = function handleSelectorChange(changed) {
    if (!changed) {
      return;
    }
    var index = configs.findIndex(function (x) {
      return x.key === changed;
    });
    if (index === -1) {
      return;
    }
    var config = __assign(__assign({}, configs[index]), {
      keyword: ''
    });
    setState(config);
    onChange === null || onChange === void 0 ? void 0 : onChange('', config);
    closeDrop();
  };
  var handleSearchBarChange = function handleSearchBarChange(changed) {
    setState(function (s) {
      return __assign(__assign({}, s), {
        keyword: changed
      });
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(changed, state);
  };
  var handleSearch = function handleSearch() {
    if (isFunction(onSearch)) {
      onSearch(state === null || state === void 0 ? void 0 : state.keyword, state);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: mergeCls,
    style: style
  }, isMulti ? /*#__PURE__*/React.createElement(Dropdown, {
    ref: dropRef
  }, /*#__PURE__*/React.createElement(Dropdown.Item, {
    title: state === null || state === void 0 ? void 0 : state.label,
    key: "select"
  }, /*#__PURE__*/React.createElement(Selector, {
    className: "ti-search-bar-selector",
    selectType: "single",
    columns: 2,
    value: state === null || state === void 0 ? void 0 : state.key,
    options: options,
    onChange: handleSelectorChange
  }))) : null, /*#__PURE__*/React.createElement(SearchBar, _extends({}, rest, {
    ref: null,
    className: "ti-search-bar",
    value: state === null || state === void 0 ? void 0 : state.keyword,
    placeholder: state === null || state === void 0 ? void 0 : state.placeholder,
    icon: null,
    onlyShowClearWhenFocus: true,
    onChange: handleSearchBarChange,
    onSearch: handleSearch
  })), showSearchText ? /*#__PURE__*/React.createElement("div", {
    className: "ti-search-trigger",
    onClick: handleSearch
  }, searchText ? searchText : /*#__PURE__*/React.createElement(SearchOutline, {
    color: "#999999",
    fontSize: 16
  })) : null);
};
var TiSearchBar$1 = /*#__PURE__*/forwardRef(TiSearchBar);

export { TiSearchBar$1 as default };
